export default "__VITE_ASSET__C2iLfRpQ__"